<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todas os Módulos..."
                            icon="fa fa-filter fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="perfils.index"
                            optionsData="id_perfil"
                            optionsDisplay="search"
                            :optionsParms="{ uso: true }"
                            v-model="filtro.id_perfil" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fa fa-search fa-fw" placeholder="Pesquisar..." v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="lista && lista.length">
                                    <span class="input-group-text">
                                        {{ lista.length }}
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            v-if="!lista.length" 
            icon="fa fa-newspaper-o"
            msg="Nenhuma novidade identificada." />

        <div v-else>
            <div class="card dashcard" v-for="(novidade, inx) in lista" :key="inx">
                <div class="card-header d-flex justify-content-between">
                    <a href="#" @click.prevent="novidade.ja_lido = !novidade.ja_lido" class="card-link">
                        {{ novidade.title }}
                    </a>
                    <div class="text-right">
                        <div class="small">
                            {{ novidade.query_group.name }}
                        </div>
                        <div v-if="!novidade.leitura">
                            <span class="badge badge-success">
                                Novidade!
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="!novidade.ja_lido">
                    <div class="small text-muted" v-if="novidade.updated_at">
                        {{ $util.getFormatDate(novidade.updated_at) }}
                        {{ novidade.updated_at.substr(11,5) }}
                    </div>
                    <div style="white-space: pre-wrap;">{{ novidade.body }}</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import AzInput from './shared/forms/AzInput.vue';
import AzPeriodo from './shared/forms/AzPeriodo.vue';
import AzEmptyState from './util/AzEmptyState.vue';
import * as moment from 'moment';

export default {
    data() { 
        return { 
            novidades: null, 
            filtro: { 
                periodo: '',
                search: "", 
                id_perfil: "", 
                inicio: "",
                fim: "", 
            }
        };
    },

    components: { 
        AzEmptyState, 
        AzInput,
        AzPeriodo, 
    }, 
    
    computed: { 
        lista: function () { 
            if ( !this.novidades )
                return [];

            let reg = this.$util.getregex(this.filtro.search);

            return this.novidades.lista.data.filter(item => ( !this.filtro.search || reg.test(JSON.stringify(item))));
        }
    },

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'usuarios',
                func: 'novidades', 
                parms: this.filtro, 
                loadTo: res => { 
                    this.novidades = res;
                }
            });
        }
    },

    beforeMount() { 
        this.filtro.inicio = moment().subtract(6, "days").format('YYYY-MM-DD');
        this.filtro.fim = moment().format('YYYY-MM-DD');
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Novidades", path: "/news"}
        ]);

        this.load();
    }
}
</script>